module.exports = __webpack_public_path__ + "img/driver.0b6d92a4.png";